/* eslint-disable linebreak-style */
export const LOAD_PRODUSE_START = 'LOAD_PRODUSE_START'; 
export const LOAD_PRODUSE_SUCCESS = 'LOAD_PRODUSE_SUCCESS'; 
export const LOAD_PRODUSE_FAILURE = 'LOAD_PRODUSE_FAILURE'; 

export const LOAD_MATERIALE_START = 'LOAD_MATERIALE_START';
export const LOAD_MATERIALE_SUCCESS = 'LOAD_MATERIALE_SUCCESS'; 
export const LOAD_MATERIALE_FAILURE = 'LOAD_MATERIALE_FAILURE'; 

export const LOAD_PRETURITABELARE_START= 'LOAD_PRETURITABELARE_START';
export const LOAD_PRETURITABELARE_SUCCESS = 'LOAD_PRETURITABELARE_SUCCESS';
export const LOAD_PRETURITABELARE_FAILURE = 'LOAD_PRETURITABELARE_FAILURE';

export const LOAD_OPTIONALE_START = 'LOAD_OPTIONALE_START'; 
export const LOAD_OPTIONALE_SUCCESS = 'LOAD_OPTIONALE_SUCCESS'; 
export const LOAD_OPTIONALE_FAILURE = 'LOAD_OPTIONALE_FAILURE'; 

export const LOAD_CULORI_START = 'LOAD_CULORI_START'; 
export const LOAD_CULORI_SUCCESS = 'LOAD_CULORI_SUCCESS'; 
export const LOAD_CULORI_FAILURE = 'LOAD_CULORI_FAILURE'; 

export const LOAD_INFORMARI_START = 'LOAD_INFORMARI_START'; 
export const LOAD_INFORMARI_SUCCESS = 'LOAD_INFORMARI_SUCCESS'; 
export const LOAD_INFORMARI_FAILURE = 'LOAD_INFORMARI_FAILURE'; 

export const LOAD_INDICATORI_START = 'LOAD_INDICATORI_START'; 
export const LOAD_INDICATORI_SUCCESS = 'LOAD_INDICATORI_SUCCESS'; 
export const LOAD_INDICATORI_FAILURE = 'LOAD_INDICATORI_FAILURE'; 

export const LOAD_FIRMA_START = 'LOAD_FIRMA_START'; 
export const LOAD_FIRMA_SUCCESS = 'LOAD_FIRMA_SUCCESS'; 
export const LOAD_FIRMA_FAILURE = 'LOAD_FIRMA_FAILURE'; 

export const LOAD_FIRME_COMISIONAR_START = 'LOAD_FIRME_COMISIONAR_START';
export const LOAD_FIRME_COMISIONAR_SUCCESS = 'LOAD_FIRME_COMISIONAR_SUCCESS';
export const LOAD_FIRME_COMISIONAR_FAILURE = 'LOAD_FIRME_COMISIONAR_FAILURE';

export const LOAD_CURS_START = 'LOAD_CURS_START'; 
export const LOAD_CURS_SUCCESS = 'LOAD_CURS_SUCCESS'; 
export const LOAD_CURS_FAILURE = 'LOAD_CURS_FAILURE'; 



